import ModalDialog from "rsuite/esm/Modal/ModalDialog";
import Modal from "../../../../Modal/Modal";
import classes from './CreateVirtualSource.module.css'
import Button2 from "../../../Button/Button2";
import { useEffect } from "react";

const SelectSensor = ({HandleSelectCamectModalForm, firmwareMajor, firmwareMinor, supportsCamect, siteType, apiData, siteGroupID, isRESUREGroup }) => {

    const HandleShowModal = () => {
        ModalDialog.current.open();
    }

    const HandleCloseModal = () => {
        ModalDialog.current.close();
        HandleSelectCamectModalForm(null);
    }

    const handleSelectCamectModalForm = (AutomationID) => {
        HandleCloseModal();
        HandleSelectCamectModalForm(AutomationID);
    }

    useEffect( () => {
        HandleShowModal()
    }, [])

    const SENSOR_OPTIONS = [
        { id: 16, label: "NB-IOT Sensor", show: () => true },
        { id: 17, label: "BLE Sensor", show: () => true },
        { id: 21, label: "Flood Sensor", show: () => true },
        { id: 22, label: "Tank sensor", show: () => true},
        { id: 1, label: "Anywhere sensor lite", show: () => isRESUREGroup == true },
        { id: 4, label: "Anywhere sensor industrial", show: () => isRESUREGroup == true },
    ];

    const context = { firmwareMajor, firmwareMinor, supportsCamect, siteType };

    return (
        <Modal ref={ModalDialog} title={"Select Sensor"} HandleShowModal={HandleShowModal} HandleCloseModal={HandleCloseModal} modalLayoutStyle={{ alignItems: "center" }}>
            <div className={classes.container}>
                {SENSOR_OPTIONS.filter(opt => opt.show(context)).map(opt => (
                    <Button2
                        key={opt.id}
                        
                        style={{
                            minWidth: "350px",
                            minHeight: "50px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                           
                        }}
                        onClick={() => handleSelectCamectModalForm(opt.id)}
                    >
                        <h4 style={{ margin: "0px" }}>{opt.label}</h4>
                    </Button2>
                ))}
            </div>
        </Modal>
    );
}

export default SelectSensor;